import { ReactNode } from "react";
import { App, Form, Input, Modal, ModalProps } from "antd";
import { useTranslation } from "react-i18next";
import { randomStr8 } from "@/utils/randomStr8";

interface SupplierUserAdd {
  name: string;
  password: string;
  mobile: string;
  areaCode: '',
}

interface UserFormProps extends ModalProps {
  handleCancel: () => void;
  handleOk: (data: SupplierUserAdd) => Promise<void>;
  supplierCode: string;
  leftTitle: ReactNode;
  confirmLoading: boolean;
}

const UserForm = ({
  handleOk,
  handleCancel,
  supplierCode,
  ...props
}: UserFormProps) => {
  const { t } = useTranslation();
  const [form] = Form.useForm<SupplierUserAdd>();
  const { notification } = App.useApp();

  const handleFinish = () => {
    form
      .validateFields()
      .then((res) => {
        const userName = res.mobile.toString()
        const value: SupplierUserAdd = {
          mobile: supplierCode + userName,
          password: res.password,
          name: supplierCode + userName,
          areaCode: ''
        };
        handleOk(value).then(() => {
          form.resetFields();
        });
      })
      .catch((err) => {
        const errTitle = t("common.addError");
        const errorDesc = err?.errorFields[0]?.errors[0] ?? "";
        notification.error({ placement: 'top',
          message: errTitle,
          description: errorDesc,
        });
      });
  };

  const onCancel = () => {
    form.resetFields();
    handleCancel();
  };

  return (
    <Modal
      centered
      width={800}
      onOk={handleFinish}
      onCancel={onCancel}
      maskClosable={false}
      title={t("common.add")}
      {...props}
    >
      <div style={{ maxHeight: "70vh", overflow: "scroll" }}>
        <Form<SupplierUserAdd>
          form={form}
          name="priceForm"
          autoComplete="off"
          layout="vertical"
          initialValues={{
            password: randomStr8()
          }}
        >
          <Form.Item
            label={t("purchase.supplierUser")}
            name="mobile"
            required
            rules={[{ required: true, message: t("components.supplierUser") }]}
          >
            <Input placeholder={t("purchase.plSupplierUser")} addonBefore={supplierCode} maxLength={3} showCount/>
          </Form.Item>
          <Form.Item
            label={t("purchase.initPwd")}
            name="password"
            required
            rules={[{ required: true, message: t("purchase.initPwd") }]}
          >
            <Input.Password disabled visibilityToggle={{ visible: true }} />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default UserForm;
